const updateSurveyMeta = payload => {
  return {
    type: 'UPDATE_SURVEY_META',
    payload: payload
  }
}

export { updateSurveyMeta }



// WEBPACK FOOTER //
// ./src/actions/index.js